import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { fromZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Returns "YYYY-MM-DD" using local calendar date, not UTC.
// toISOString().split('T')[0] is wrong west of UTC: local midnight converts to the
// previous UTC day, producing a date string one day behind.
export function toLocalDateStr(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Format a `HH:MM` slot string for display in the user's local timezone.
// `sourceTz` is the timezone the slot string belongs to (server returns this
// alongside slots). `dateStr` is the YYYY-MM-DD the slot falls on. Without
// sourceTz/dateStr, falls back to raw 12-hour formatting.
export function formatSlotInLocalTz(
  time: string | null | undefined,
  dateStr: string | null | undefined,
  sourceTz?: string | null,
): string {
  if (!time) return '';
  if (!sourceTz || !dateStr) {
    const [h, m] = time.split(':').map(Number);
    const period = h >= 12 ? 'PM' : 'AM';
    const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
  }
  try {
    const utcInstant = fromZonedTime(`${dateStr}T${time}:00`, sourceTz);
    return format(utcInstant, 'h:mm a');
  } catch {
    return time;
  }
}
